__webpack_require__.p = "https://cdn.n-tv.de/sport/0.72.1/_next/";